import type { OperationalEvent, ScreenEvent, UIEvent } from '../new-analytics-types';

import { Action, ActionSubject, OperationalAction, OperationalSubject } from '../new-analytics-types';

const sideNavList = 'sideNavList';
const profilePopupMenu = 'profilePopupMenu';

export const iaNavSideListEvents = {
  screen: {
    sideNavList: (): ScreenEvent => ({
      data: {
        name: sideNavList,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87494',
    }),
  },
  ui: {
    iaSideNavigationItemClicked: (attributes: {
      title: string;
      dynamic: boolean;
      nav4: boolean;
      navigationItemType: string;
      path?: string;
      toggle?: string;
      newIA: boolean;
    }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.NavigationItem,
        actionSubjectId: 'navigate',
        source: sideNavList,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87740',
    }),
    optInEvent: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.DropdownItem,
        actionSubjectId: 'newNavigationOptIn',
        source: profilePopupMenu,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87741',
    }),
    optOutEvent: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.DropdownItem,
        actionSubjectId: 'newNavigationOptOut',
        source: profilePopupMenu,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87484',
    }),
    newNavigationSelectorButtonClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'newNavigationSelector',
        source: profilePopupMenu,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87490',
    }),
    newNavigationFeedbackSubmitEvent: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'newNavigationFeedbackSubmit',
        source: profilePopupMenu,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87485',
    }),
    newNavigationFeedbackCloseEvent: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'newNavigationFeedbackClose',
        source: profilePopupMenu,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87487',
    }),
    orgSelectorDropdownOrgSelectEvent: (): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.DropdownItem,
        actionSubjectId: 'orgSelectorDropdownItemOrgSelected',
        source: sideNavList,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87488',
    }),
    orgSelectorDropdownViewAllOrgSelectEvent: (): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.DropdownItem,
        actionSubjectId: 'orgSelectorDropdownItemViewAllSelected',
        source: sideNavList,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87489',
    }),
    orgSelectorDropdownClicked: (isOpen: boolean): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Dropdown,
        actionSubjectId: 'orgSelectorDropdownClicked',
        source: sideNavList,
        attributes: {
          isOpen,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87492',
    }),
    navigationSideBarToggle: (sideNavOpen: boolean): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'navigationSideBarToggle',
        source: sideNavList,
        attributes: {
          sideNavOpen,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/87493',
    }),
  },
  operational: {
    parentOrgQueryFetchedResults: (attributes: {
      siteId: string;
      orgName: string;
      orgId: string;
      hasError: boolean;
      error?: string;
      isOrgAdmin?: boolean;
    }): OperationalEvent => ({
      data: {
        action: OperationalAction.Fetched,
        actionSubject: OperationalSubject.ParentOrgQuery,
        actionSubjectId: 'parentOrgQueryFetchedResults',
        source: sideNavList,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88273', // rename analytics event
    }),
    siteQueryFetchedResults: (attributes: {
      siteId: string;
      siteName: string;
      siteAvatarUrl: string;
      hasError: boolean;
      error?: string;
    }): OperationalEvent => ({
      data: {
        action: OperationalAction.Fetched,
        actionSubject: OperationalSubject.SiteQuery,
        actionSubjectId: 'siteQueryFetchedResults',
        source: sideNavList,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88274',
    }),
  },
};
